import React from "react";
import { ModalContext } from "contexts/modalContext";
import { PaymentLinkIcon } from "./PaymentLinkIcon";
import gtmEvents from "utils/gtmEvents";
import { Button } from "reactstrap";
import { MassivePaymentLinkDiscovery } from "./MassivePaymentLinkDiscovery";

import __ from "utils/i18n";

export const MassivePaymentLink = () => {
  return (
    <ModalContext.Consumer>
      {(context) => (
        <li className="dashboard-header__item-container nav-item payment-link">
          <div className="nav-link" data-name="massive-payment-link">
            <Button
              onClick={() => {
                gtmEvents.paymentLinkButtonClicked();
                context.openModal("MassivePaymentLinkModal");
              }}
              color="primary"
              size="sm"
              className="dashboard-header__button payment-link-radius"
            >
              <PaymentLinkIcon /> {__("dashboard.sections.massivePaymentLink.title")}
            </Button>
          </div>
          <MassivePaymentLinkDiscovery />
        </li>
      )}
    </ModalContext.Consumer>
  );
};
